var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getRole != 2)?_c('comments-field',{attrs:{"messages":_vm.comments,"document":"connection","documentId":_vm.document._id,"partner":_vm.document.partner._id},on:{"toUpdate":_vm.updateComments}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }